export default __webpack_public_path__ + "static/media/edit-icon.97b774df.svg";